<template>
  <page-outline :title="$t('businessDocuments.form_document_request_title')"
    icon="icon-sent" returnUrl="/home/">
    <template slot="pageContent">

      <!-- File Type -->
      <form-accordion :title="$t('attachments.file')">
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input isMandatory
              :inputLabel="$t('businessDocuments.document_type')"
              :inputType="'listeSelect'" :mandatoryErrorIndicator="fileTypeSelectedError">
              <select class="form-control" id="sel2" readonly v-model="fileTypeSelected"
                @change="checkFileType">
                <option value="">{{ $t('businessDocuments.slct_doct_type') }}</option>
                <option v-for="fileType in fileTypeList" :key="fileType.fileTypeValue"
                  :value="fileType.fileTypeValue"
                  :disabled="fileType.disabled"
                  :style="fileType.disabled ? 'font-style:italic;' : ''">
                  {{ $t(fileType.fileTypeLabel) }}
                </option>
              </select>
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group" v-if="fileTypeSelected == 'ACTE'">
            <form-write-group-label-input v-model="requestName" isMandatory
              :inputLabel="$t('businessDocuments.serialize.ACTE.SIREN')"
              :placeholderValue="$t('businessDocuments.serialize.ACTE.SIREN')"
              :mandatoryErrorIndicator="requestNameError"
              :regexpErrorIndicator="requestNameRegexpError">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group" v-else>
            <form-write-group-label-input v-model="requestName" isMandatory
              :inputLabel="$t('businessDocuments.request_name')"
              :placeholderValue="$t('businessDocuments.request_name')"
              :mandatoryErrorIndicator="requestNameError">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>

      <hr/>

      <!-- Recipient Information -->
      <form-accordion :title="$t('contacts.recipient_label')">
        <b-form-group v-if="fileTypeSelected == 'ACTE'">
          <b-form-radio class="creationFormBtnRadio" v-model="contactType"
            name="radios-locationTypeFile" value="1">
            {{ $t('common.contact_label') }}
          </b-form-radio>&nbsp;&nbsp;
          <b-form-radio style="margin-left: 35px;" class="creationFormBtnRadio" v-model="contactType"
            @change="getSharedFolders($engine.user.get().identifier)"
            name="radios-locationTypeFile" value="2">
            {{ $t('common.institut_label') }}
          </b-form-radio>
        </b-form-group>

        <!-- Recipient Data -->
        <b-row v-if="contactType === '1'">
          <b-col sm="6" class="form-group">
            <form-dropdown-label-input v-model="selectedContact" isMandatory
              :inputLabel="$t('common.nme')"
              :placeholderValue="$t('common.recipient_name')"
              :mandatoryErrorIndicator="recipientNameError"
              valueKey="name"
              subTextKey="identifier"
              objectKey="id">
            </form-dropdown-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="recipientEmail" isMandatory
              :inputLabel="$t('common.idtfr')"
              :placeholderValue="$t('common.recipient_email')"
              :mandatoryErrorIndicator="recipientEmailError"
              :regexpErrorIndicator="recipientEmailRegexpError">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>

      <hr v-if="sharedFoldersConfig"/>

      <!-- Shared Folders -->
      <form-accordion :title="$t('businessDocuments.shared_folders')" v-if="sharedFoldersConfig">

        <b-form-group>
          <b-row>
            <b-col sm="6" class="form-group">
              <b-form-radio v-model="sharedFolderType"
                class="creationFormBtnRadio"
                name="radios-sharedFolderType" value="1">
                {{ $t('businessDocuments.slct_sdr') }}
              </b-form-radio>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input isMandatory
                :inputLabel="$t('businessDocuments.slct_sdr')" :hiddenLabel="true"
                :inputType="'listeSelect'" :mandatoryErrorIndicator="folderIdError">
                <select class="form-control" id="sel2" readonly v-model="folderId">
                  <option value="">{{ $t('creation_forms.slct_a_dr') }}</option>
                  <option v-for="(value, index) in jsonOfSharedFolders" :key="index"
                          :value="index">
                    {{ value }}
                  </option>
                </select>
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6" class="form-group">
              <b-form-radio v-model="sharedFolderType"
                class="creationFormBtnRadio"
                name="radios-sharedFolderType" value="2">
                {{ $t('businessDocuments.add_sdr') }}
              </b-form-radio>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="folderName" isMandatory
                :inputLabel="$t('businessDocuments.shared_folder_name')" :hiddenLabel="true"
                :placeholderValue="$t('businessDocuments.shared_folder_name')"
                :mandatoryErrorIndicator="folderNameError">
              </form-write-group-label-input>
            </b-col>
          </b-row>
        </b-form-group>
      </form-accordion>

      <hr />

      <!-- Comment Zone -->
      <form-accordion :title="$t('common.add_msg')">
        <b-row>
          <b-col class="form-group">
            <textarea v-model="formMessage"
              class="form-control inputAccordionForm" style="margin-top: 4px;"
              :placeholder="$t('common.general_msg')">
            </textarea>
          </b-col>
        </b-row>
      </form-accordion>
    </template>
    <template slot="footerButtons">
      <b-row class="justify-content-start">
        <b-col md="3" offset-md="8" class="form-group">
          <f7-button class="button-action milkyBlockBlack"
            @click="requestBusinessDocument">
            <f7-icon fa="paper-plane"></f7-icon>
            {{ $t('businessDocuments.form_document_request_button') }}
          </f7-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>
<script>
import moment from 'moment'

import FormAccordion from '@/components/common/FormAccordion.vue'
import formDropdownLabelInput from '@/components/common/formDropdownLabelInput.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import documentSerialize from '@/helpers/documentSerialize.json'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage, reloadPage} from '@/helpers/routing'
import {verifyMandatoryValues, verifyRegexpValues, checkErrorFlag} from '@/helpers/validator'

/** @author TLV - JPR 06/11/2020
* @brief Component for requesting Business Documents
*/
export default {
  name: 'RequestDocumentForm',
  components: {
    'form-accordion': FormAccordion,
    'form-dropdown-label-input': formDropdownLabelInput,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      contacts: [],
      contactType: '1',
      fileTypeSelected: '',
      fileTypeSelectedError: false,
      fileTypeList: [],
      folderId: '',
      folderIdError: false,
      formMessage: '',
      folderName: '',
      folderNameError: false,
      jsonOfContacts: {},
      contactSelected: false,
      jsonOfSharedFolders: {},
      requestName: '',
      requestNameError: false,
      requestNameRegexpError: false,
      recipientEmail: '',
      recipientEmailError: false,
      recipientEmailRegexpError: false,
      recipientName: '',
      recipientNameError: false,
      selectedContact: {},
      selectedRecipient: {},
      sharedFoldersConfig: this.$engine.services.businessDocuments.sharedFoldersConfig,
      sharedFolderType: '2'
    }
  },
  watch: {
    selectedContact: function (val) {
      this.recipientName = val.name ? val.name : ''
      this.recipientEmail = val.identifier ? val.identifier : ''
    }
  },
  created () {
    // Generate fileTypeList from documentSerialize
    let keys = Object.keys(documentSerialize)
    for (var i = 0; i < keys.length; i++) {
      let fileType = {}
      fileType.fileTypeValue = keys[i]
      fileType.fileTypeLabel = documentSerialize[keys[i]].label
      fileType.disabled = documentSerialize[keys[i]].disabled
      this.fileTypeList.push(fileType)
    }
    if (this.sharedFoldersConfig) {
      this.getSharedFolders(this.$engine.user.get().identifier)
    }
    this.setContactSelectionEvent()
    this.contacts = this.$engine.contacts.get()
  },
  methods: {
    checkFileType () {
      if (this.fileTypeSelected === 'ACTE') {
        let today = new Date()
        this.folderName = 'ACTE ' + today.toLocaleDateString()
      }
    },
    getSharedFolders (user) {
      this.jsonOfSharedFolders = {}
      let that = this
      this.$engine.services.businessDocuments.update()
      .then(response => {
        let sharedFolders = response.data.groups
        for (var i = 0; i < sharedFolders.length; i++) {
          if (sharedFolders[i].owner === user || sharedFolders[i].correspondent === user) {
            that.jsonOfSharedFolders[sharedFolders[i].idgroup] = sharedFolders[i].reference
          }
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    // Event for retrieving selected contact from contact selection button
    setContactSelectionEvent () {
      let contacts = this.$engine.contacts.get()
      this.jsonOfContacts = {}
      for (var i = 0; i < contacts.length; i++) {
        this.jsonOfContacts[contacts[i].id] = contacts[i]
      }
      let that = this
      // Retrieve selected contact id and load associated data
      this.$bus.$on('refresh-debtor-contact-list', (data) => {
        that.selectedRecipient = that.jsonOfContacts[data]
        that.recipientName = that.selectedRecipient.name
        that.recipientEmail = that.selectedRecipient.identifier
        that.contactSelected = true
        // Default folder name is the recipient name
        that.folderName = that.recipientName
      })
    },
    validateForm () {
      let flagsList = {
        'recipientName': false,
        'recipientEmail': false,
        'folderId': false,
        'folderName': false,
        'fileTypeSelected': false,
        'requestName': false
      }
      let mandatoryValues = []
      let regexpValues = {}
      if (this.contactType === '1') {
        mandatoryValues = ['recipientName', 'recipientEmail', 'fileTypeSelected', 'requestName']
        regexpValues = {
          'recipientEmail': 'Email'
        }
      } else {
        mandatoryValues = ['fileTypeSelected', 'requestName']
      }
      if (this.fileTypeSelected === 'ACTE') {
        regexpValues = {
          'requestName': 'SIREN'
        }
      }
      flagsList = verifyMandatoryValues(mandatoryValues, flagsList, this)
      flagsList = verifyRegexpValues(regexpValues, flagsList, this)
      if (this.sharedFolderType === '1' && this.folderId === '') {
        this.folderIdError = true
        flagsList.folderId = true
        this.folderNameError = false
        flagsList.folderName = false
      } else if (this.sharedFolderType === '2' && this.folderName === '') {
        this.folderNameError = true
        flagsList.folderName = true
        this.folderIdError = false
        flagsList.folderId = false
      }
      let errorFlag = checkErrorFlag(flagsList)
      return !errorFlag
    },
    requestBusinessDocument () {
      if (!this.validateForm()) {
        this.$f7.alert(this.$i18n.t('errors.errors_in_form_details'), this.$i18n.t('errors.errors_in_form'))
        return
      }
      this.$f7.showPreloader(this.$i18n.t('loading.sending_document_request'))
      let that = this
      let jsonToCreate = {}
      let randomIdDoc = 'DOC_' + moment().format('YYYYMMDDhhmmss') + '_' + Math.random().toString(36).substr(2, 6)
      let randomIdGrp = 'GRP_' + moment().format('YYYYMMDDHHmmss') + '_' + Math.random().toString(36).substr(2, 6)

      if (this.contactType === '2') {
        jsonToCreate = {
          Receiver: 'INPI',
          AttachmentId: randomIdDoc,
          SIREN: that.requestName
        }
        if (that.sharedFolderType === '1') {
          jsonToCreate.IdGroup = that.folderId
          jsonToCreate.GroupId = randomIdGrp
          jsonToCreate.GroupLabelReference = that.jsonOfSharedFolders[that.folderId]
        } else if (that.sharedFolderType === '2') {
          jsonToCreate.GroupLabelReference = that.folderName
          jsonToCreate.GroupId = randomIdGrp
        }
        that.$engine.services.businessDocuments.createAPI(jsonToCreate)
        .then(response => {
          that.status = response.status
          if (response.status === 200) {
            that.$f7.hidePreloader()
            that.$f7.modal({
              title: that.$i18n.t('success.document_request_sent'),
              text: '<i class="icon fa fa-check"></i>'
            })
            setTimeout(function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/inbox/'})
            }, 2000)
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      } else {
        jsonToCreate = {
          Receiver: that.recipientEmail,
          AttachmentId: randomIdDoc,
          AttachmentRequestType: that.fileTypeSelected,
          AttachmentRequestName: that.requestName,
          AttachmentRequestDescription: that.formMessage,
          AttachmentOthers: {'Serialize': {}}
        }
        if (that.sharedFolderType === '1') {
          jsonToCreate.IdGroup = that.folderId
          jsonToCreate.GroupId = randomIdGrp
          jsonToCreate.GroupLabelReference = that.jsonOfSharedFolders[that.folderId]
        } else if (that.sharedFolderType === '2') {
          jsonToCreate.GroupLabelReference = that.folderName
          jsonToCreate.GroupId = randomIdGrp
        }
        that.$engine.services.businessDocuments.create(jsonToCreate)
        .then(response => {
          that.status = response.status
          if (response.status === 200) {
            that.$f7.hidePreloader()
            that.$f7.modal({
              title: that.$i18n.t('success.document_request_sent'),
              text: '<i class="icon fa fa-check"></i>'
            })
            setTimeout(function () {
              that.$f7.closeModal()
              reloadPage(that, {url: '/inbox/', force: true, ignoreCache: true})
            }, 2000)
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// RequestDocumentTemplate.vue?30139158